var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 16.8C11.3005 16.8 10.6005 16.53 10.0705 16L3.55051 9.47998C3.26051 9.18998 3.26051 8.70998 3.55051 8.41998C3.84051 8.12998 4.32051 8.12998 4.61051 8.41998L11.1305 14.94C11.6105 15.42 12.3905 15.42 12.8705 14.94L19.3905 8.41998C19.6805 8.12998 20.1605 8.12998 20.4505 8.41998C20.7405 8.70998 20.7405 9.18998 20.4505 9.47998L13.9305 16C13.4005 16.53 12.7005 16.8 12.0005 16.8Z",
    fill: "#60656C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.847cd228395d8a2a8ac1df8d12ce3f9b.svg";
export { ForwardRef as ReactComponent };